import { CloudAnalyticsModel, type RunReportChannelStatus } from "@doitintl/cmp-models";
import { getCollection, modelServerTimestamp } from "@doitintl/models-any";
import { DateTime } from "luxon";

export const createRunReportChannel = async ({
  uid,
  email,
  status,
}: {
  uid: string;
  email: string;
  status: RunReportChannelStatus;
}) => {
  const docRef = await getCollection(CloudAnalyticsModel)
    .doc("reports")
    .collection("cloudAnalyticsRunReportChannels")
    .add({
      uid,
      email,
      status,
      timeUpdated: modelServerTimestamp(),
      expireBy: DateTime.utc().plus({ days: 1 }).toJSDate(),
    });

  return docRef.id;
};
